const CHANNEL = "web";
const VERSION = "0";

export { CHANNEL, VERSION };
